import React from "react"
import cx from "classnames"
import {useHistory, Link} from "react-router-dom"
import {useTranslation} from "react-i18next"
import {ExportOutlined} from "@ant-design/icons"
import {Icon} from "components/Icon"
import styles from "./SideBar.module.css"

export function Menu(props) {
    const history = useHistory()
    const {t} = useTranslation(["sidebar"])
    const {menu, onOpenChildMenus, isActive} = props
    const {icon, title, url, externalUrl, badge, childs} = menu
    const isEmptyChild = !childs || !childs.length

    const onClickMenu = () => {
        if (!childs || !childs.length) {
            history.push(url)
        } else {
            onOpenChildMenus(menu)
        }
    }

    const renderContent = () => {
        return (
            <>
                {!!icon && (
                    <span className={styles.menuIcon}>
                        <Icon icon={icon} />
                    </span>
                )}
                <p className={styles.menuTitle}>{title}</p>
            </>
        )
    }

    if (externalUrl) {
        return (
            <a
                href={externalUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${title}${badge ? ` ${badge}` : ""} ${t("menu.opensInNewTab")}`}
                className={cx(styles.menu, styles.menuExternal)}>
                {renderContent()}
                {!!badge && <span className={styles.menuBadge}>{badge}</span>}
                <ExportOutlined className={styles.menuExternalIcon} aria-hidden />
            </a>
        )
    }

    if (isEmptyChild) {
        return (
            <Link to={url}>
                <div
                    className={cx(styles.menu, {
                        [styles.menuActive]: isActive
                    })}>
                    {renderContent()}
                </div>
            </Link>
        )
    }

    return (
        <div
            onClick={onClickMenu}
            className={cx(styles.menu, {
                [styles.menuActive]: isActive
            })}>
            {renderContent()}
        </div>
    )
}
